import axios from "axios";
import {
    authHeader,
    handleResult,
    handleException,
    globalStore
} from '../helpers';

export const companyService = {
    getAll,
    getById,
    deleteById,
    getCompanyUsers,
    save
};

function getAll() {
    if(globalStore.companies)
    {
        console.log("Companies exists in cache");
        return new Promise((resolve) => resolve(globalStore.companies))
    }

    console.log("No companies definitions exists in cache, calling API");
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("company", requestOptions).then(handleResult).then(p => {
        globalStore.companies = p;
        return p;
    }).catch(handleException);
}

function getById(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.get("company/" + companyId, requestOptions).then(handleResult).catch(handleException);
}

function getCompanyUsers(companyId) {
    const requestOptions = {
        headers: authHeader()
    };
    return axios.get("company/" + companyId + "/users", requestOptions).then(handleResult).catch(handleException);
}

function deleteById(companyId) {
    const requestOptions = {
        headers: authHeader()
    };

    return axios.delete("company/" + companyId, requestOptions).then(handleResult).catch(handleException);
}

function save(company) {
    const requestOptions = {
        headers: authHeader()
    };

    if(!company.id || company.id == 0) {
        return axios.post("company", company, requestOptions).then(handleResult).catch(handleException);
    }

    return axios.patch("company/" + company.id, company, requestOptions).then(handleResult).catch(handleException);
}